import styled from "styled-components";
import {
  GREEN_BORDER,
  GREEN_FADE_BG,
  TEXT_DARK,
  GREEN,
} from "../../constants/theme";

export const ReadyWrap = styled.section`
  border-top: 1px solid #e2e8f0;
  background: ${GREEN_FADE_BG};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
`;
export const ReadyInner = styled.div`
  width: 100%;
  max-width: 768px;
  padding: 64px 16px;
  margin: 0 auto;
  text-align: center;
`;
export const ReadyH2 = styled.h2`
  color: ${TEXT_DARK};
  font-weight: 700;
  margin: 0 0 12px 0;
  font-size: 1.875rem;
  text-align: center;
  @media (min-width: 768px) {
    font-size: 2.25rem;
    white-space: nowrap;
  }
`;
export const ReadyP = styled.p`
  color: #334155;
  margin: 0 0 32px 0;
  line-height: 1.6;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
`;
export const ContactCard = styled.div`
  border: 1px solid ${GREEN_BORDER};
  border-radius: 14px;
  padding: 24px;
  background: #fff;
  max-width: 640px;
  margin: 0 auto;
  text-align: left;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`;
export const ContactTitle = styled.div`
  text-align: center;
  font-weight: 600;
  font-size: 1.125rem;
  margin-bottom: 16px;
`;
export const Form = styled.form`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;
export const Label = styled.label`
  display: grid;
  gap: 6px;
  font-size: 0.9rem;
  color: #0f172a;
`;
export const Input = styled.input`
  border: 1px solid ${GREEN_BORDER};
  border-radius: 8px;
  padding: 10px 12px;
  outline: none;
`;
export const Textarea = styled.textarea`
  border: 1px solid ${GREEN_BORDER};
  border-radius: 8px;
  padding: 10px 12px;
  outline: none;
  height: 112px;
`;
export const Full = styled.div`
  grid-column: 1 / -1;
`;
export const SendRow = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
`;
export const SendBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 10px;
  font-weight: 600;
  color: #fff;
  background: ${GREEN};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.15s ease;
  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }
`;
